import { DialogContent, Fade } from '@mui/material';
import MarkdownRenderer from './MarkdownRenderer';
import { ModalHeader } from './modals';
import FuseLoading from '@/@fuse/core/FuseLoading';
import { useNewHelp } from '@/utils/newHelpHook';
import { useEffect, useState } from 'react';
import { titleFromSlug } from '@/utils/newHelpManager';

export default function HelpModal() {

  const { loading, getDocument } = useNewHelp();
  const [data, setData] = useState<{ title: string, markdown: string } | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (loading) return;

    let cancelled = false;

    (async () => {
      try {
        setIsFetching(true);
        const document = await getDocument();

        if (!cancelled && document) {
          setData({ title: titleFromSlug(document.slug), markdown: document.markdown });
        }

        setIsFetching(false);
      } catch (e) {
        console.warn('Error fetching help document', e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loading, getDocument]);


  if (isFetching) {
    return (
      <Fade in appear timeout={300} key="loading">
        <DialogContent>
          <div className="flex flex-col items-center justify-center">
            <FuseLoading />
            <div className="mt-4 text-lg text-gray-600">
              Fetching latest help content...
            </div>
          </div>
        </DialogContent>
      </Fade>
    );
  }

  return (
    <Fade in appear timeout={300} key="content">
      <div>
        <ModalHeader title={data?.title || ''} />
        <DialogContent>
          <MarkdownRenderer markdown={data?.markdown || ''} />
        </DialogContent>
      </div>
    </Fade>
  );
}
